"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionFrequenciesMap = exports.subscriptionSchemaProperties = exports.SubscriptionSchema = exports.SubscriptionTypeEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
const SubscriptionStatusEnum = zod_1.z.enum([
    "canceled",
    "scheduled",
    "active",
    "complete",
    "paused",
    "processing",
]);
var SubscriptionTypeEnum;
(function (SubscriptionTypeEnum) {
    SubscriptionTypeEnum["MonthlyPlan"] = "monthly-plan";
    SubscriptionTypeEnum["AnnualPlan"] = "annual-plan";
})(SubscriptionTypeEnum || (exports.SubscriptionTypeEnum = SubscriptionTypeEnum = {}));
exports.SubscriptionSchema = base_schema_1.BaseSchema.extend({
    subscriptionId: zod_1.z.string(),
    totalInvoiceCount: zod_1.z.number().optional(),
    total: zod_1.z.number(),
    totalCollectable: zod_1.z.number().optional(),
    invoicePricing: zod_1.z.object({
        amount: zod_1.z.number().min(0),
        tax: zod_1.z.number().min(0).optional(),
        total: zod_1.z.number().min(0),
    }),
    currency: zod_1.z.string(),
    title: zod_1.z.string(),
    status: SubscriptionStatusEnum,
    invoiceCount: zod_1.z.number(),
    startDate: zod_1.z.date(),
    coachUserId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    frequency: zod_1.z.object({
        interval: zod_1.z.string(),
        intervalCount: zod_1.z.number().optional(),
        description: zod_1.z.string(),
    }),
    resumeAt: zod_1.z.date().optional(),
    smartActionTemplates: zod_1.z.array(smart_action_schema_1.SmartActionTemplateSchema).optional(),
    packageInstanceId: zod_1.z.string().optional(),
});
exports.subscriptionSchemaProperties = {
    collectionName: "subscriptions",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
exports.subscriptionFrequenciesMap = {
    weekly: {
        title: "Every week",
        description: "Weekly",
        data: {
            interval: "week",
            intervalCount: 1,
        },
    },
    biWeekly: {
        title: "Every two weeks",
        description: "Two week",
        data: {
            interval: "week",
            intervalCount: 2,
        },
    },
    monthly: {
        title: "Every month",
        description: "Monthly",
        data: {
            interval: "month",
            intervalCount: 1,
        },
    },
    biMonthly: {
        title: "Every two months",
        description: "Two month",
        data: {
            interval: "month",
            intervalCount: 2,
        },
    },
    quarterly: {
        title: "Every three months",
        description: "Three month",
        data: {
            interval: "month",
            intervalCount: 3,
        },
    },
    semiAnnual: {
        title: "Every six months",
        description: "Six month",
        data: {
            interval: "month",
            intervalCount: 6,
        },
    },
    yearly: {
        title: "Every year",
        description: "Yearly",
        data: {
            interval: "year",
            intervalCount: 1,
        },
    },
};
//# sourceMappingURL=subscription-schema.js.map